import { useMap } from '@vis.gl/react-google-maps'
import { lazy, Suspense } from 'react'
import type { GoogleParcelsLayerProps } from './GoogleParcelsLayer'

const GoogleParcelsLayer = lazy(() => import('./GoogleParcelsLayer'))

export default function LazyGoogleParcelsLayer(
  props: GoogleParcelsLayerProps
) {
  const map = useMap()

  if (!props.enabled || !map) {
    return null
  }

  return (
    <Suspense fallback={null}>
      <GoogleParcelsLayer {...props} />
    </Suspense>
  )
}
